<template>
  <div class="form__radio-container" :class="[themes[theme]]">
    <label
      :for="id"
      class="form-radio-label custom-control-label block"
      :class="[themes_labes[theme]] "
    >
      <input
        class="form__radio mr-2"
        type="radio"
        :id="id"
        :name="name"
        :value="value"
        @change="onChange"
        :checked="state"
        :readonly="readonly"
        :disabled="disabled"
      />
      <span class="checkmark"></span>

      <slot></slot>
    </label>
  </div>
</template>

<style>
/* Customize the label (the form-radio-label) */
.form-radio-label {
  position: relative;
  padding-left: 25px;
  padding-bottom: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}

/* Hide the browser's default radio button */
.form-radio-label input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom radio button */
.form-radio-label .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 17px;
  width: 17px;
  /* background-color: #eee; */
  border: 1px solid #1d3964;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.form-radio-label:hover input ~ .checkmark {
  /* background-color: #ccc; */
  border: 1px solid #1d3964;
}

/* When the radio button is checked, add a blue background */
.form-radio-label input:checked ~ .checkmark {
  /* background-color: #2196F3; */
  border: 1px solid #ee0049;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.form-radio-label .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.form-radio-label input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.form-radio-label .checkmark:after {
  top: 3px;
  left: 3px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #ee0049;
}
</style>

<script>
export default {
  name: "sp-radio",
  data() {
    return {
      themes: {
        default: "",
        form: "",
        dark: "button--dark"
      },
      themes_labes: {
        default: "mb-5",
        form: "text-blue text-2sm mb-2",
        dark: "button--dark"
      }
    };
  },

  model: {
    prop: "modelValue",
    event: "input"
  },

  props: {
    name: {
      required: true,
      type: String
    },

    id: {
      required: true,
      type: String
    },

    value: {
      required: false,
      type: String|Boolean,
      default: ""
    },

    modelValue: {
      default: undefined
    },

    checked: {
      required: false,
      type: Boolean,
      default: false
    },

    readonly: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      required: false,
      type: String,
      default: ""
    }
  },

  computed: {
    state() {
      if (this.modelValue === undefined) {
        return this.checked;
      }

      return this.modelValue === this.value;
    }
  },

  methods: {
    onChange() {
      this.toggle();
    },

    toggle() {
      this.$emit("input", this.value);
    }
  },

  watch: {
    checked(value) {
      if (value !== this.state) {
        this.toggle();
      }
    }
  },

  mounted() {
    if (this.checked && !this.state) {
      this.toggle();
    }
  }
};
</script>
